export const blockcypherMethods = {
    getBalance: async (client, baseUrl, { address }) => {
        const apiUrl = `${baseUrl}/addrs/${address}`;
        const response = (await client.request({
            url: apiUrl,
            fetchOptions: { method: 'GET' },
        }));
        if (response.error) {
            return {
                error: { code: -1, message: response.error },
            };
        }
        return {
            result: BigInt(response.balance),
        };
    },
};
//# sourceMappingURL=blockcypher.js.map